import React from 'react';
import '../styles/ChooseFloorPlanModal.css';

/**
 * A DXF's model space holds the whole sheet set — plans, elevations,
 * sections, often a survey — so when the extractor finds more than one
 * floor plan the user picks which to import.
 *
 * Deliberately blocking: taking the first plan silently would drop every
 * other storey of a multi-storey drawing without saying so.
 *
 * Props:
 *   plans      — [{ index, story, window, evidence }] from the extractor
 *   onChoose(index), onCancel
 */
function ChooseFloorPlanModal({ plans, onChoose, onCancel }) {
  if (!plans?.length) return null;

  const feet = (a, b) => Math.round(Math.abs(b - a) / 12);

  return (
    <div className="choose-plan-overlay" onClick={onCancel}>
      <div className="choose-plan-modal" onClick={(e) => e.stopPropagation()}>
        <h2>Which floor plan?</h2>
        <p className="choose-plan-hint">
          This drawing contains {plans.length} floor plans. Elevations and
          sections have already been excluded.
        </p>
        <div className="choose-plan-list">
          {plans.map((plan) => {
            const [x0, x1, y0, y1] = plan.window;
            return (
              <button
                key={plan.index}
                className="choose-plan-option"
                onClick={() => onChoose(plan.index)}
              >
                <strong>
                  {plan.story != null
                    ? `Story ${plan.story}`
                    : `Plan ${plan.index + 1}`}
                </strong>
                <span className="choose-plan-size">
                  {feet(x0, x1)}ft × {feet(y0, y1)}ft
                </span>
              </button>
            );
          })}
        </div>
        <div className="choose-plan-actions">
          <button className="choose-plan-cancel" onClick={onCancel}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

export default ChooseFloorPlanModal;
